import { connect } from 'react-redux';
import { AdminResetResendReopen } from '../../components/pages/survey-admin/AdminResetResendReopen';
import { IApplicationState } from '../../store';
import { ActionCreators as DistributionContactActionCreators } from '../../store/DistributionContactStore';
import { ActionCreators as SurveyAdminStoreActionCreators } from '../../store/SurveyAdminStore';
import { ActionCreators as SurveyParticipantActionCreators } from '../../store/SurveyParticipantStore';

export const AdminResetReopenResendPage: React.ComponentType<{ surveyId: number; audienceId: number }> = connect(
	(state: IApplicationState) => ({
		...state.surveyAdmin,
		...state.distributionContacts,
		...state.distributionList,
		...state.surveyParticipants,
	}),
	{
		...DistributionContactActionCreators,
		...SurveyAdminStoreActionCreators,
		...SurveyParticipantActionCreators,
	},
)(AdminResetResendReopen);
